import styled from "styled-components";

export const StyledMatchPromoButton = styled.div`
  width: 100%;
  height: 26px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  color: ${({ theme }) => theme.rgba.white_120};
  line-height: ${({ theme }) => theme.mixins.pxToRem(12)};
  font-size: ${({ theme }) => theme.mixins.pxToRem(11)};
  font-weight: 500;
  font-style: normal;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.07),
    0px 0px 0px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.rgba.white_100};
`;
